<template>
  <div class="message-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span>{{ pageTitle }}</span>
        <el-button type="primary" size="small" @click="showAddDialog">
          <i class="el-icon-plus"></i> 新建消息
        </el-button>
      </div>

      <!-- 搜索区域 -->
      <el-form :inline="true" class="search-form">
        <el-form-item label="消息类型">
          <el-select v-model="searchForm.type" placeholder="全部" clearable style="width: 150px">
            <el-option label="系统通知" value="system"></el-option>
            <el-option label="获赞通知" value="like"></el-option>
            <el-option label="评论通知" value="comment"></el-option>
            <el-option label="下载通知" value="download"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input 
            v-model="searchForm.keyword" 
            placeholder="标题或内容"
            @keyup.enter.native="handleSearch"
            clearable
            style="width: 200px">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table :data="messageList" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="type" label="类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'system'" type="primary">系统通知</el-tag>
            <el-tag v-else-if="scope.row.type === 'like'" type="danger">获赞通知</el-tag>
            <el-tag v-else-if="scope.row.type === 'comment'" type="success">评论通知</el-tag>
            <el-tag v-else-if="scope.row.type === 'download'" type="warning">下载通知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
        <el-table-column prop="content" label="内容" min-width="250" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userId" label="接收用户" width="100">
          <template slot-scope="scope">
            {{ scope.row.userId ? `用户${scope.row.userId}` : '全局消息' }}
          </template>
        </el-table-column>
        <el-table-column prop="isRead" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isRead === 0" type="danger" size="small">未读</el-tag>
            <el-tag v-else type="info" size="small">已读</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; margin-top: 20px;">
      </el-pagination>
    </el-card>

    <!-- 新建/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="600px"
      :close-on-click-modal="false"
      @close="handleDialogClose">
      <el-form :model="messageForm" :rules="rules" ref="messageForm" label-width="100px">
        <el-form-item label="消息类型" prop="type">
          <el-select v-model="messageForm.type" placeholder="请选择" style="width: 100%">
            <el-option label="系统通知" value="system"></el-option>
            <el-option label="获赞通知" value="like"></el-option>
            <el-option label="评论通知" value="comment"></el-option>
            <el-option label="下载通知" value="download"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息标题" prop="title">
          <el-input v-model="messageForm.title" placeholder="请输入消息标题"></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input 
            type="textarea" 
            v-model="messageForm.content" 
            :rows="4"
            placeholder="请输入消息内容">
          </el-input>
        </el-form-item>
        <el-form-item label="接收用户">
          <el-input 
            v-model.number="messageForm.userId" 
            placeholder="留空表示全局消息"
            type="number">
          </el-input>
          <span style="color: #909399; font-size: 12px;">提示：留空则所有用户可见</span>
        </el-form-item>
        <el-form-item label="相关链接">
          <el-input v-model="messageForm.link" placeholder="选填，可以是资源链接等"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MessageManage',
  data() {
    return {
      pageTitle: '消息管理', // 默认标题
      searchForm: {
        type: '',
        keyword: ''
      },
      messageList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新建消息',
      messageForm: {
        id: null,
        type: '',
        title: '',
        content: '',
        userId: null,
        link: ''
      },
      rules: {
        type: [{ required: true, message: '请选择消息类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入消息标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入消息内容', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.loadPageTitle()
    this.loadData()
  },
  methods: {
    // 动态加载页面标题
    async loadPageTitle() {
      try {
        const menuData = localStorage.getItem('admin_menu_data')
        if (menuData) {
          const menus = JSON.parse(menuData)
          const allMenus = menus.menus || []
          const currentMenu = allMenus.find(m => m.url === this.$route.path)
          if (currentMenu) {
            this.pageTitle = currentMenu.name
          }
        }
      } catch (error) {
        console.error('加载页面标题失败:', error)
      }
    },
    async loadData() {
      this.loading = true
      try {
        const res = await this.$axios.get('/admin/message/list', {
          params: {
            current: this.currentPage,
            size: this.pageSize,
            type: this.searchForm.type || null,
            keyword: this.searchForm.keyword || null
          }
        })
        if (res.data.code === 200) {
          this.messageList = res.data.data.records
          this.total = res.data.data.total
        }
      } catch (error) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    resetSearch() {
      this.searchForm = {
        type: '',
        keyword: ''
      }
      this.currentPage = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadData()
    },
    showAddDialog() {
      this.dialogTitle = '新建消息'
      this.messageForm = {
        id: null,
        type: '',
        title: '',
        content: '',
        userId: null,
        link: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑消息'
      this.messageForm = {
        id: row.id,
        type: row.type,
        title: row.title,
        content: row.content,
        userId: row.userId,
        link: row.link
      }
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.messageForm.validate(async (valid) => {
        if (!valid) return

        try {
          const url = this.messageForm.id ? '/admin/message/update' : '/admin/message/create'
          const method = this.messageForm.id ? 'put' : 'post'
          
          const res = await this.$axios[method](url, this.messageForm)
          
          if (res.data.code === 200) {
            this.$message.success(this.messageForm.id ? '更新成功' : '创建成功')
            this.dialogVisible = false
            this.loadData()
          } else {
            this.$message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          this.$message.error('操作失败')
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这条消息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$axios.delete(`/admin/message/${id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadData()
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    handleDialogClose() {
      this.$refs.messageForm.resetFields()
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.message-manage {
  padding: 20px;
  background: transparent;
  min-height: calc(100vh - 60px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}
</style>
